import { Link } from 'react-router-dom'
import type { Warehouse } from '../types'

function freshness(value?:string) {
  if (!value) return 'Давно не подтверждалось'
  const days = Math.floor((Date.now()-new Date(value).getTime())/86400000)
  return days <= 0 ? 'Подтверждено сегодня' : days === 1 ? 'Подтверждено вчера' : `Подтверждено ${days} дн. назад`
}

export default function WarehouseCard({item}:{item:Warehouse}) {
  return <article className="warehouse-card">
    <div className="card-topline">
      <span className={item.accepts_new_clients ? 'status active' : 'status closed'}>{item.accepts_new_clients ? 'Принимает клиентов' : 'Приём закрыт'}</span>
      <span className="freshness">{freshness(item.last_confirmed_at)}</span>
    </div>
    <h3><Link to={`/warehouse/${item.slug}`}>{item.title}</Link></h3>
    <div className="company-name">{item.company_name}</div>
    <div className="location">{item.region_name}, {item.city_name}{item.public_address ? ` · ${item.public_address}` : ''}</div>
    <div className="tags">
      {item.marketplaces?.map(m => <span key={m.code}>{m.title}</span>)}
      {item.categories?.slice(0,4).map(c => <span key={c.code}>{c.title}</span>)}
    </div>
    <div className="card-metrics">
      <div><b>{item.free_orders_per_day ?? item.orders_per_day_capacity ?? '—'}</b><small>заказов/сутки свободно</small></div>
      <div><b>{item.overall_score ? Number(item.overall_score).toFixed(1) : '—'}</b><small>рейтинг</small></div>
      <div><b>{item.verified_reviews_count ?? 0}</b><small>проверенных отзывов</small></div>
    </div>
    <Link className="button full" to={`/warehouse/${item.slug}`}>Посмотреть условия</Link>
  </article>
}
